import { Elements, Loader, TextButton } from '@tfo/common'
import { useState } from 'react'
import { useIntl } from "react-intl"
import $http from '../../../../utils/$http'

import './AdditionalInformation.scss'

const { Paragraph, TextArea } = Elements

export type AdditionalInformationProps = {
    orderId: number
    body: string
}

const AdditionalInformation = (props: AdditionalInformationProps) => {
    const intl = useIntl()
    const [body, setBody] = useState(props.body)
    const [savedBody, setSavedBody] = useState("")
    const [error, setError] = useState<number | null>(null)
    const [isLoading, setIsLoading] = useState(false)
    const [saved, setSaved] = useState(false)

    const onSaveAdditionalInformation = async () => {
        if (body === props.body || body === savedBody) {
            return
        }

        setIsLoading(true)
        setError(null)
        setSaved(false)
        setSavedBody(body)

        try {
            await $http.post(`attach/${props.orderId}/additional-information`, { body })
            setSaved(true)
        }
        catch (e) {
            console.error(e)

            let error = e as {
                response: {
                    status: number
                }
            }

            if (error.response === undefined) {
                setError(999)
            }
            else {
                setError(500)
            }
        }
        finally {
            setIsLoading(false)
        }
    }

    return <div className='additional-information'>
        <TextArea
            placeholder={intl.formatMessage({ id: 'requireAttachments.additional-information.placeholder' })}
            value={body}
            onChange={(e) => setBody(e.target.value)} />
        <Paragraph className='message' small >
            {error && intl.formatMessage({ id: `requireAttachments.attach.additional-information-fail-${error}` })}
            {saved && intl.formatMessage({ id: 'requireAttachments.saved.additional-information' })}
        </Paragraph>
        <TextButton
            className='save-button save-button--right'
            onClick={onSaveAdditionalInformation}
            disabled={body.trim() === "" || body === props.body || body === savedBody}>
            {intl.formatMessage({ id: 'requireAttachments.attach.additional-information' })}
        </TextButton>
        {isLoading && <Loader />}
    </div>
}

export default AdditionalInformation